import { IRI } from 'emt-library'

const APIRoutes = {
  // Registration
  GetRegistration: {
    method: 'GET',
    path: '/v2/petsitter_registrations',
  },
  PostRegistration: {
    method: 'POST',
    path: '/v2/petsitter_registrations',
  },
  UpdateRegistration: {
    method: 'PATCH',
    path: '/v2/petsitter_registrations',
  },
  // END Registration

  // Edit profile
  GetEditProfile: {
    method: 'GET',
    path: '/v2/petsitting/account',
  },
  UpdateEditProfile: {
    method: 'PATCH',
    path: '/v2/petsitting/account',
  },
  PostPictureMain: {
    method: 'POST',
    path: '/v2/petsitting/pictures/main',
  },
  PostChangePictureMain: (id: string) => ({
    method: 'POST',
    path: `/v2/petsitting/pictures/${id}/main`,
  }),
  PostPictures: {
    method: 'POST',
    path: '/v2/petsitting/pictures',
  },
  UpdatePicturePosition: (id: string) => ({
    method: 'PATCH',
    path: `/v2/petsitting/pictures/${id}`,
  }),
  DeletePicture: (id: string) => ({
    method: 'DELETE',
    path: `/v2/petsitting/pictures/${id}`,
  }),
  // END Edit profile

  // Settings
  GetSettings: {
    method: 'GET',
    path: '/v2/petsitting/account/settings',
  },
  UpdateSettings: {
    method: 'PATCH',
    path: '/v2/petsitting/account/settings',
  },
  // END settings

  // Services
  GetServices: {
    method: 'GET',
    path: '/v2/petsitting/account/services',
  },
  UpdateServices: {
    method: 'PATCH',
    path: '/v2/petsitting/account/services',
  },
  DeleteOfferSittingHome: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/customer_home_sitting`,
  },
  UpdateOfferSittingHome: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/customer_home_sitting`,
  },
  DeleteOfferVisitHour: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/visit_hour`,
  },
  UpdateOfferVisitHour: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/visit_hour`,
  },
  DeleteOfferWalkHour: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/walk_hour`,
  },
  UpdateOfferWalkHour: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/walk_hour`,
  },
  DeleteOfferVisitHalfHour: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/visit_half_hour`,
  },
  UpdateOfferVisitHalfHour: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/visit_half_hour`,
  },
  DeleteOfferWalkHalfHour: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/walk_half_hour`,
  },
  UpdateOfferWalkHalfHour: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/walk_half_hour`,
  },
  DeleteOfferSittingPetsitterHome: {
    method: 'DELETE',
    path: `/v2/petsitting/account/services/offers/petsitter_home_sitting`,
  },
  UpdateOfferSittingPetsitterHome: {
    method: 'PUT',
    path: `/v2/petsitting/account/services/offers/petsitter_home_sitting`,
  },
  // END Services

  // Calendar
  GetPetsitterCalendar: (id: string) => ({
    method: 'GET',
    path: `/v2/petsitting/profiles/${id}/calendar`,
  }),
  GetCalendar: {
    method: 'GET',
    path: '/v2/petsitting/calendar',
  },
  GetReservationCalendar: (id: string) => ({
    method: 'GET',
    path: `/v2/petsitting/calendar/reservation/${id}`,
  }),
  AddEvent: {
    method: 'POST',
    path: '/v2/petsitting/calendar/events',
  },
  DeleteEvent: (id: string) => ({
    method: 'DELETE',
    path: `/v2/petsitting/calendar/events/${id}`,
  }),
  UpdateMainEvent: {
    method: 'PUT',
    path: `/v2/petsitting/calendar/main_event`,
  },
  // END Calendar

  // Calendar Registration
  GetCalendarRegistration: {
    method: 'GET',
    path: '/v2/petsitter_registrations/calendar',
  },
  AddEventRegistration: {
    method: 'POST',
    path: '/v2/petsitter_registrations/calendar/events',
  },
  DeleteEventRegistration: (id: string) => ({
    method: 'DELETE',
    path: `/v2/petsitter_registrations/calendar/events/${id}`,
  }),
  UpdateMainEventRegistration: {
    method: 'PUT',
    path: `/v2/petsitter_registrations/calendar/main_event`,
  },
  // END Calendar Registration

  // Search
  GetSearch: {
    method: 'GET',
    path: '/v2/petsitting/profiles',
  },
  // END Search

  // View profile
  GetProfile: (id: string) => ({
    method: 'GET',
    path: `/v2/petsitting/profiles/${id}`,
  }),
  GetStats: (id: string) => ({
    method: 'GET',
    path: `/v2/petsitting/profiles/${id}/stats`,
  }),
  GetPet: (id: string) => ({
    method: 'GET',
    path: `/animals/${id}`,
  }),
  GetPrice: (id: string) => ({
    method: 'POST',
    path: `/v2/petsitting/profiles/${id}/cart/compute`,
  }),
  // END View profile

  // Dashboard
  GetReservation: (reservationUuid: string) => ({
    method: 'GET',
    path: `/v2/petsitting/reservations/${reservationUuid}`,
  }),
  GetReservationCard: (reservationUuid: string) => ({
    method: 'GET',
    path: `/v2/petsitting/reservations/${reservationUuid}/cart`,
  }),
  GetReservationMessage: (conversationUuid: string) => ({
    method: 'GET',
    path: `/v2/converations/petsitting/${conversationUuid}`,
  }),
  GetStripeAccount: () => ({
    method: 'GET',
    path: '/v2/petsitting/account/onboarding_url',
  }),
  ForceCheckPayoutStatus: () => ({
    method: 'POST',
    path: '/v2/petsitting/account/payout_status/force_check',
  }),
  // END Dashboard

  // Reservations
  GetConversations: {
    method: 'GET',
    path: `/v2/petsitting/conversations`,
  },
  GetConversation: () => ({
    method: 'GET',
  }),
  GetRequestCarts: {
    method: 'GET',
    path: `/v2/petsitting/request_carts?tenders=true`,
  },
  PostMessage: () => ({
    method: 'POST',
  }),
  ReplyMessage: () => ({
    method: 'POST',
  }),
  ReactMessage: () => ({
    method: 'POST',
  }),
  RemoveMessage: () => ({
    method: 'DELETE',
  }),
  HasPendingMission: {
    method: 'GET',
    path: '/v3/petsitting/informations/has-pending-mission',
  },
  // END Reservations

  // Quote
  GetQuote: (id?: string) => ({
    method: 'GET',
    path: id ? `/v2/petsitting/quotes/${id}` : '/v2/petsitting/quotes',
  }),
  GetConversationId: (id: string) => ({
    method: 'GET',
    path: `/v2/petsitting/quotes/${id}/conversation`,
  }),
  AcceptQuote: (acceptIRI: IRI) => ({
    method: 'POST',
    path: acceptIRI,
  }),
  RejectQuote: (rejectIRI: IRI) => ({
    method: 'POST',
    path: rejectIRI,
  }),
  CancelQuote: (cancelIRI: IRI) => ({
    method: 'POST',
    path: cancelIRI,
  }),
  ConfirmQuote: (confirmIRI: IRI) => ({
    method: 'POST',
    path: confirmIRI,
  }),
  ContestQuote: (contestIRI: IRI) => ({
    method: 'POST',
    path: contestIRI,
  }),
  GetQuotePaymentIntent: (paymentIntentIRI: IRI) => ({
    method: 'POST',
    path: paymentIntentIRI,
  }),
  // END Quote

  // Cart
  GetCart: {
    method: 'GET',
    path: '/v2/petsitting/cart',
  },
  UpdateCart: {
    method: 'POST',
    path: '/v2/petsitting/cart',
  },
  CheckoutCart: {
    method: 'POST',
    path: '/v2/petsitting/cart/checkout',
  },
  CheckCart: {
    method: 'POST',
    path: '/v2/petsitting/cart/check',
  },
  // END Cart

  // Tenders
  PostTenders: {
    method: 'POST',
    path: '/petsitting/tenders',
  },
  GetTenders: (id?: string) => ({
    method: 'GET',
    path: id ? `/petsitting/tenders/${id}` : '/petsitting/tenders',
  }),
  GetTendersPaymentIntent: (paymentIntentIRI: IRI) => ({
    method: 'POST',
    path: paymentIntentIRI,
  }),
  AcceptTenders: (acceptIRI: IRI) => ({
    method: 'POST',
    path: acceptIRI,
  }),
  // END Tenders
  // Missions
  JoinMission: (id: string) => ({
    method: 'POST',
    path: `/v2/petsitting/request/${id}/join`,
  }),
  GetMissions: (id?: string) => ({
    method: 'GET',
    path: id ? `/v2/petsitting/quotes_tenders/${id}` : '/v2/petsitting/quotes_tenders',
  }),
  // END Missions
}

export default APIRoutes
